if (!customElements.get("m-slideshow")) {
  class MSlideshow extends HTMLElement {
    constructor() {
      super();
      this.lastVideo = null;
    }

    connectedCallback() {
      this.showArrows = this.dataset.enableArrows === "true";
      this.showDots = this.dataset.enableDots === "true";
      this.sliderContainer = this.querySelector(".swiper-container");

      this.initSlider();
    }

    initSlider() {
      this.slider = new MinimogLibs.Swiper(this.sliderContainer, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: true,
        effect: "fade",
        fadeEffect: { crossFade: true },
        speed: 900,

        // ✅ 5 Second Autoplay
        autoplay: {
          delay: 5000, // 5000ms = 5 seconds
          disableOnInteraction: false,
        },

        navigation: this.showArrows
          ? {
              nextEl: this.querySelector(".m-slider-controls__button-next"),
              prevEl: this.querySelector(".m-slider-controls__button-prev"),
            }
          : false,

        pagination: this.showDots
          ? {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
              bulletClass: "m-dot",
              bulletActiveClass: "m-dot--active",
            }
          : false,
      });

      this.slider.on("slideChange", this.handleChange.bind(this));
    }

    handleChange(swiper) {
      const slide = swiper.slides[swiper.activeIndex];
      const slideType = slide && slide.dataset.slideType;

      if (this.lastVideo) {
        this.lastVideo.pause();
        this.lastVideo.currentTime = 0;
        this.lastVideo = null;
      }

      if (slideType === "video_slide") {
        const video = slide.querySelector("video");

        if (video) {
          if (this.slider.autoplay) {
            this.slider.autoplay.stop();
          }

          video.play();
          this.lastVideo = video;

          video.onended = () => {
            if (this.slider.autoplay) {
              this.slider.autoplay.start();
            }
          };
        }
      }
    }
  }

  customElements.define("m-slideshow", MSlideshow);
}
